<template>
  <div class="article-page">
    <single-article :articleId="$route.params.id">
      <template slot-scope="props">
        <div class="single-post" v-if="props.article">
          <div class="post-title-area">
            <router-link class="post-cat" :to="{ name: 'ArticlesForCategory', params: { categoryValue: props.article[websiteCategory], category: websiteCategory } }" v-if="props.article[websiteCategory]">
              {{ getCategory(websiteCategory, props.article[websiteCategory]).name }}
            </router-link>
            <router-link class="post-cat" :to="{ name: 'ArticlesForCategory', params: { categoryValue: props.article[websiteSecondCategory], category: websiteSecondCategory } }" v-if="props.article[websiteSecondCategory]">
              {{ getCategory(websiteSecondCategory, props.article[websiteSecondCategory]).name }}
            </router-link>
            <h2 class="post-title">
              {{ props.article.title }}
            </h2>
            <div class="post-meta">
              <span class="post-date"><i class="fa fa-clock-o"></i> {{ props.article.date }}</span>
            </div>
          </div>

          <div class="post-content-area">
            <div class="entry-content" v-html="props.article.body_html"></div>
            <div class="share-items clearfix">
              <ul class="post-social-icons unstyled">
                <li class="facebook">
                  <a href="https://www.facebook.com/sharer/sharer.php" target="_blank">
                    <i class="fa fa-facebook"></i> <span class="ts-social-title">Facebook</span></a>
                </li>
                <li class="twitter">
                  <a :href="`https://twitter.com/home?status=${pageUrl}`" target="_blank">
                    <i class="fa fa-twitter"></i> <span class="ts-social-title">Twitter</span></a>
                </li>
                <li class="gplus">
                  <a :href="`https://plus.google.com/share?url=${pageUrl}`" target="_blank">
                    <i class="fa fa-google-plus"></i> <span class="ts-social-title">Google +</span></a>
                </li>
                <li class="linkedin">
                  <a :href="`https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}`" target="_blank">
                    <i class="fa fa-linkedin"></i> <span class="ts-social-title">Linkedin</span></a>
                </li>
              </ul>
            </div><!-- Share items end -->
            <mail-transfer :id="props.article.oid" :broadcastChannel="broadcastChannel"/>
            <h4>Sujets similaires</h4>
            <div class="similarArticles">
                <ul>
                <li v-for="(similarArticle, index) in props.article.similarArticles">
                    <a :href="`https://${similarArticle.hostname}/articles/${similarArticle.oid}/${similarArticle.slug}`" target="_blank">{{ similarArticle.title }}</a><br/>
                </li>
                </ul>
            </div>
          </div><!-- post-content end -->
          <div id="comments" class="comments-area block">
            <h3 class="block-title"><span>Commentaires</span></h3>
            <comments :id="props.article.oid"></comments>
          </div>
        </div><!-- Single post end -->
      </template>
    </single-article>
    <br/>
    <read-more/>
  </div>
</template>

<script>
  import { SingleArticle, ArticleTags, Comments, categories, MailTransfer } from 'itrnews-vuejs-api';
  import website from '../mixins/website';
  import ReadMore from './ReadMore';

  export default {
    name: 'ArticlePage',
    components: { ReadMore, SingleArticle, ArticleTags, Comments, MailTransfer },
    mixins: [website, categories],
    mounted() {
      this.pageUrl = window.location.href;
    },
    data() {
      return {
        tags: [],
        pageUrl: '',
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ArticlePage.vue